import cn from 'clsx'
import LineBedIcon from 'components/Luxkit/Icons/line/LineBedIcon'
import SolidStarCircleIcon from 'components/Luxkit/Icons/solid/SolidStarCircleIcon'
import CaptionTextBlock from 'components/Luxkit/TextBlocks/CaptionTextBlock'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const MarkerContainer = styled.div`
  position: relative;
  border-radius: ${(props) => props.theme.borderRadius.large};
  padding: ${rem(4)} ${rem(8)};
  background-color: ${(props) => props.theme.palette.neutral.eight};
  box-shadow: ${(props) => props.theme.shadow.bottom.small};
  &.exclusive {
    border: 1px solid
      ${(props) => props.theme.palette.product.exclusive};
  }

  &.premium {
    border: 1px solid ${(props) => props.theme.palette.product.premium};
  }

  &.partner {
    border: 1px solid ${(props) => props.theme.palette.product.partner};
  }

  &.visited {
    background-color: ${(props) => props.theme.palette.neutral.six};
  }

  &.active {
    color: ${(props) => props.theme.palette.neutral.eight};
    &.exclusive {
      background-color: ${(props) => props.theme.palette.product.exclusive};
    }

    &.premium {
      background-color: ${(props) => props.theme.palette.product.premium};
    }

    &.partner {
      background-color: ${(props) => props.theme.palette.product.premium};
    }
  }
`

const StyledSolidStarCircleIcon = styled(SolidStarCircleIcon)`
  color: ${(props) => props.theme.palette.product.exclusive};
  &.active {
    color: ${(props) => props.theme.palette.neutral.eight};
  }
`

interface Props {
  marker: App.SearchMapMarker;
  isActive: boolean;
  formattedLabel: string | null;
  isVisited: boolean;
  setIsHovered: React.Dispatch<React.SetStateAction<string | null>>;
  isHovered: boolean;
}

function PropertyPriceMarker(props: Props) {
  const {
    marker,
    isActive,
    formattedLabel,
    isVisited,
    setIsHovered,
    isHovered,
  } = props

  const offer = marker.offers[0]

  const offerTypeMap = {
    hotel: {
      icon: <StyledSolidStarCircleIcon className={isHovered || isActive ? 'active' : ''} />,
      type: 'exclusive',
    },
    default: {
      icon: null,
      type: 'partner',
    },
  }

  const { icon, type } = offerTypeMap[offer.type] || offerTypeMap.default

  return (
    <MarkerContainer
      className={cn(type, {
        active: isActive || isHovered,
        visited: isVisited,
      })}
      onMouseEnter={() => setIsHovered(marker.id)}
      onMouseLeave={() => setIsHovered(null)}
    >
      {formattedLabel && <CaptionTextBlock startIcon={icon} variant="large">
        {formattedLabel}
      </CaptionTextBlock>}
      {!formattedLabel && <CaptionTextBlock startIcon={<LineBedIcon />} variant="large" />}
    </MarkerContainer>
  )
}

export default PropertyPriceMarker
